import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyAmenityViewQuery,
  useAmenityCreateMutation,
  useAmenityUpdateMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const AmenityView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;

  const [name, setName] = useState("");
  const [states, setStates] = useState("");
  const [image, setImage] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [statesErr, setStatesErr] = useState(false);
  const [imageErr, setImageErr] = useState(false);
  const [btn, setBtn] = useState(false);
  const [stateList, setStateList] = useState([]);

  // RTK QUERY
  const [addApi] = useAmenityCreateMutation();
  const [editApi] = useAmenityUpdateMutation();
  const [viewApi] = useLazyAmenityViewQuery();

  const submitHandler = () => {
    let count = 1;

    if ((types !== "edit" && image?.length == 0) || name?.length == 0) {
      setNameErr(true);
      if (types !== "edit") {
        setImageErr(true);
      }
    } else {
      let formdata = new FormData();
      formdata.append("name", name);
      if (image?.name) {
        formdata.append("image", image);
      }

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        formdata.append("_method", "PUT");
        editApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/amenity-list");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err");
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        addApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status === "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/amenity-list");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.error("Error", err);
          });
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    viewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          setImage(res?.amenity?.image);
          setName(res?.amenity?.name);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={types == "edit" ? "edit-amenity" : "add-amenity"} />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Amenity Image 55 x 55 (pixel)
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setImage(e.target.files[0])}
                  type={"file"}
                  accept="image/jpeg, image/png"
                />
              </div>
              {image?.length == 0 && imageErr && (
                <p className="err">Add Image</p>
              )}
            </div>

            {image && (
              <div className="col-md-6 mb-3">
                <div className="mt-3 mx-3">
                  <img
                    src={image?.name ? URL.createObjectURL(image) : image}
                    style={{ width: "200px" }}
                  />
                </div>
              </div>
            )}
          </Row>
          <Row>
            <div className="col-md-12 text-start mx-3 mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default AmenityView;
